import { connect } from 'react-redux';

import { getCoworkingOrOfferAmenitiesSelector } from 'shared/store/coworking/selectors/smart/getCoworkingOrOfferAmenitiesSelector';
import { IApplicationState } from 'shared/types/redux';

import { Amenities as AmenitiesComponent } from './Amenities';
import { IAmenitiesProps } from './types';

export const mapStateToProps = (state: IApplicationState): IAmenitiesProps => ({
  amenities: getCoworkingOrOfferAmenitiesSelector(state),
});

export const Amenities = connect(mapStateToProps)(AmenitiesComponent);
